import { useMemo } from 'react';
import { usePrintsUiStore } from '../stores/use-prints-ui-store';
import { usePrintsConfigStore } from '../stores/use-prints-config-store';

import { getSelectedDeliveryOption } from '../utils/delivery-options';

export const useSelectedDeliveryOption = () => {
  const selectedDeliveryKey = usePrintsUiStore(
    (state) => state.selectedDeliveryKey,
  );
  const allDeliveryOptions = usePrintsConfigStore(
    (state) => state.allDeliveryOptions,
  );

  return useMemo(
    () => getSelectedDeliveryOption(allDeliveryOptions, selectedDeliveryKey),
    [allDeliveryOptions, selectedDeliveryKey],
  );
};
